// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"b67045e8","737":"61ef0b01"}[chunkId] + ".chunk.css";
};